import React, { useEffect, useState } from 'react';
import { Container } from './styles';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
import { useDispatch, useSelector } from 'react-redux';
import { cleanFabricationPurchaseOrderSettings } from '../../../../store/ducks/fabrication-purchase-order/actions';
import { EProvideWireQuantityTypes } from '../../../../store/ducks/fabrication-purchase-order/types';
import { ApplicationState } from '../../../../store';
import { FabricationPurchaseOrderService } from '../../../../services/FabricationPurchaseOrder';
import { loadContracts } from '../../../../store/ducks/fabrication-contracts/actions';
import { loadFabricationOrders } from '../../../../store/ducks/fabrication-orders/actions';
import successOrderImg from '../../../../assets/images/successOrder.svg';
import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto/Button';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import { addToast } from '../../../../store/ducks/toast/actions';

const FabricationOrderSucess: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );
  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const [contractNumber] = useState(
    fabricationPurchaseOrder.constructionIdentification.contractNumber
  );
  const [createdOrderId] = useState(fabricationPurchaseOrder.createdOrderId);

  const fabricationOrdersState = useSelector(
    (state: ApplicationState) => state.fabricationOrders
  );

  const fabricationState = useSelector(
    (state: ApplicationState) => state.fabrication
  );

  const [loadingPDF, setLoadingPDF] = useState(false);

  const onFabricationPurchaseOrderSuccess = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(loadContracts(customerViewType));
    dispatch(cleanFabricationPurchaseOrderSettings());

    if (
      contractNumber &&
      fabricationOrdersState.selectedContractNumbers.includes(contractNumber)
    ) {
      const { selectedStartDate, selectedEndDate } = fabricationOrdersState;
      dispatch(
        loadFabricationOrders(
          fabricationOrdersState.selectedContractNumbers,
          selectedStartDate,
          selectedEndDate
        )
      );
    }
  };

  useEffect(() => {
    onFabricationPurchaseOrderSuccess();
    // eslint-disable-next-line
    dispatch(
      sendTagging({
        screenName:
          'LG:Comprar:CorteEDobra:RevisaoDoPedido:SolicitacaoConcluida',
        event: 'page_view',
        page: window.location.pathname,
        contratoObra: contractNumber
      })
    );

    const { constructionIdentification, detailingProject, extraItens } =
      fabricationPurchaseOrder;

    const tipoPedido = constructionIdentification.comingFromBuyAgain
      ? 'recompra'
      : constructionIdentification.gerdauRevisionNumber
      ? 'revisao'
      : 'novo';

    const projetosAnexados = detailingProject.itens
      .filter((item) => item.projectId)
      .map((item) => {
        const fileName = item.projectSelected?.fileName || '';
        return {
          nome_arquivo: fileName,
          tipo_arquivo: `.${fileName.split('.').pop() || ''}`,
          revisao: item.revision,
          pavimento_informado: item.pavements.length > 0,
          numero_repeticoes: item.amount ?? 1,
          desenho_completo: item.completeDrawing,
          detalhes_elementos_preenchido: item.observation !== ''
        };
      });

    const pieceTypes = fabricationState.pieceTypesState?.pieceTypes || [];
    const steelTypes = fabricationState.steelTypesState?.steelTypes || [];
    const allDiameters = steelTypes.flatMap(
      (st) => st.diametersState?.diameters || []
    );

    const itensExtras = extraItens.otherPieces
      .filter((piece) => piece.pieceTypeId !== undefined)
      .map((piece) => ({
        tipo_peca: piece.pieceTypeId,
        tipo_peca_descricao:
          pieceTypes.find((p) => p.id === piece.pieceTypeId)?.description ?? '',
        tipo_aco: piece.steelTypeId,
        tipo_aco_descricao:
          steelTypes.find((s) => s.id === piece.steelTypeId)?.description ?? '',
        bitola: piece.diameterId,
        bitola_descricao:
          allDiameters.find((d) => d.id === piece.diameterId)?.size ?? '',
        medida_a: piece.measureA,
        medida_b: piece.measureB,
        medida_c: piece.measureC,
        quantidade: piece.amount
      }));

    const arameRecozido = extraItens.annealedWires
      .filter((wire) => wire.annealedWireTypeId !== undefined)
      .map((wire) => ({
        bitola: wire.annealedWireTypeId,
        peso_kg: wire.weight,
        quantidade:
          wire.provideQuantityBy === EProvideWireQuantityTypes.PERCENTAGE
            ? wire.percentage
            : wire.weight,
        tipo_quantidade: wire.provideQuantityBy
      }));

    dispatch(
      sendTagging({
        screenName:
          'LG:Comprar:CorteEDobra:RevisaoDoPedido:SolicitacaoConcluida',
        itemName: 'comprar_corteEDobra_revisaoDoPedido_finalizarPedido',
        event: 'success',
        itemDescription: 'comprar_corteEDobra_revisaoDoPedido_finalizarPedido',
        nonInteraction: true,
        contratoObra: contractNumber,
        filterInfo: `#cttObra:${contractNumber}`,
        extraData: {
          numero_pedido:
            fabricationPurchaseOrder.createdOrderId?.toString() || '',
          identificacao_pedido: constructionIdentification.orderNumber,
          data_desejada: constructionIdentification.desiredDate || '',
          torre: constructionIdentification.towers.join(','),
          tipo_produto: detailingProject.productType,
          veiculos_selecionados:
            detailingProject.vehiclesTypes?.join(',') || '',
          possui_projeto_anexado: projetosAnexados.length > 0,
          quantidade_arquivos_projeto: projetosAnexados.length,
          projetos_anexados_pedido: projetosAnexados,
          possui_itens_extras: itensExtras.length > 0,
          quantidade_itens_extras: itensExtras.length,
          itens_extras_carrinho: itensExtras,
          possui_arame_recozido: arameRecozido.length > 0,
          quantidade_arame_recozido: arameRecozido.length,
          arame_recozido_carrinho: arameRecozido,
          tipo_pedido: tipoPedido,
          peso_total_pedido: 0
        }
      })
    );
  }, []);

  const onClickDownloadPDF = async () => {
    if (!createdOrderId) {
      return;
    }

    setLoadingPDF(true);

    try {
      const fabricationPurchaseOrderBase64 =
        await FabricationPurchaseOrderService.downloadPurchaseOrderPDF(
          createdOrderId
        );
      const pdfFileName = `Pedido_${contractNumber}_${createdOrderId}`;

      const dataurl =
        'data:text/plain;base64,' + fabricationPurchaseOrderBase64;
      const element = document.createElement('a');
      element.setAttribute('href', dataurl);
      element.setAttribute('download', `${pdfFileName}.pdf`);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (err) {
      console.error(err);
      dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Não foi possível baixar o PDF do pedido. Tente novamente.'
        })
      );
    } finally {
      setLoadingPDF(false);
    }

    dispatch(
      sendTagging({
        screenName:
          'LG:Comprar:CorteEDobra:RevisaoDoPedido:SolicitacaoConcluida',
        itemName: 'button:baixar_pdf_do_pedido',
        itemDescription: `comprar_corteEDobra_revisaoDoPedido_solicitacaoConcluida_baixarPdfDoPedido`,
        contratoObra: contractNumber,
        event: 'click'
      })
    );
  };

  const navigateToOrders = () => {
    dispatch(
      sendTagging({
        screenName:
          'LG:Comprar:CorteEDobra:RevisaoDoPedido:SolicitacaoConcluida',
        itemName: 'button:ir_para_pedidos',
        itemDescription: `comprar_corteEDobra_revisaoDoPedido_solicitacaoConcluida_irParaPedidos`,
        event: 'click'
      })
    );
    history.push(`${ERoutes.ORDERS}`);
  };

  return (
    <Container>
      <img src={successOrderImg} alt="Gerdau" />
      <Title level={2}>Solicitação concluída</Title>
      <div className="info-text" data-testid="sucessText">
        Recebemos sua compra com sucesso! Em até 2 dias úteis, enviaremos e-mail
        de confirmação de atendimento da(s) sua(s) data(s) desejada(s). <br />
        Você poderá acompanhar os status dos seus pedidos através do menu Meus
        pedidos.
      </div>
      <div className="btn-box">
        <Button
          name="downloadPdf"
          fullWidth
          onClick={onClickDownloadPDF}
          loading={loadingPDF}
          disabled={loadingPDF}
        >
          Baixar PDF do pedido
        </Button>
        <Button
          name="navigateToOrders"
          variant="secondary"
          fullWidth
          onClick={() => navigateToOrders()}
        >
          Ir para Pedidos
        </Button>
      </div>
    </Container>
  );
};

export default FabricationOrderSucess;
